<a
  [routerLink]="!baseCard ? productUrl : null"
  [class.discount]="product.splash && product.originalPrice !== product.price"
  (click)="baseCard ? openProductDialog($event) : null"
>
  @if (!product.productDeliveryLimit?.hidden && product.productDeliveryLimit; as deliveryLimit) {
    <div class="delivery-limit badge">
      {{ deliveryLimit.label }}
    </div>
  }
  @if (product.badgeUrl; as badgeUrl) {
    <img class="product-card-badge badge" [src]="badgeUrl | cms: 75 : 80" alt="badge" />
  }
  @if (savings) {
    <app-savings [savings]="savings" class="badge"></app-savings>
  }
  <div class="product-card-image-container">
    <img [srcset]="product | productSizes: big" [src]="product | primary" [alt]="product.productDisplayName" />
    @if (primaryTag && primaryTag.showFrontend === true) {
      <span class="primary-tag" [ngStyle]="{ 'background-color': primaryTag.color }">
        @if (primaryTag.icon) {
          <mat-icon [svgIcon]="primaryTag.icon" class="primary-tag-icon"></mat-icon>
        }
        {{ primaryTag.name }}
      </span>
    }
  </div>
  <b class="product-card-name">{{ product.productDisplayName }}</b>
  @if (!product.altPriceText) {
    <app-price [value]="price" class="price-text"></app-price>
  }
  @if (product.altPriceText) {
    <span class="price-text" [class.small]="smallAltText">{{ product.altPriceText }}</span>
  }
  @if (product.splash && product.originalPrice !== product.price) {
    <span class="product-card-original-price"> {{ originalPriceLabel }} {{ product.originalPrice | number: '.2-2' : locale }} </span>
  }
</a>

<div class="buttons">
  @if (!product.hasModules) {
    @let entry = isProductLine((basketProducts$ | async)[product.id]);
    @if (!entry) {
      <app-text-button (click)="addProduct(product.minCount)" [disabled]="product.forSale === false">
        {{ addToBasketLabel }}
      </app-text-button>
    }
    @if (entry) {
      <app-counter
        [count]="entry.quantity"
        [minCount]="product.minCount"
        (add)="addProduct($event.quantity)"
        (remove)="removeProduct(entry.quantity, $event.quantity)"
      ></app-counter>
    }
  }
  @if (product.hasModules) {
    <app-text-button [routerLink]="productUrl" [disabled]="product.forSale === false">
      {{ chooseVariationLabel }}
    </app-text-button>
  }
</div>
